import { useCallback } from 'react'
import {
  dashboardv99990101Client,
  Dashboardv99990101Api
} from '@sequencehq/api/dashboard/v99990101'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { Product, IntegrationId } from 'Products/types'
import omit from 'lodash/omit'

type UpdatedProduct = Omit<
  Product,
  'createdAt' | 'updatedAt' | 'id' | 'xeroLedgerAccountMappings'
> & {
  integrationIds?: IntegrationId[]
  xeroLedgerAccountMappings?: Dashboardv99990101Api.PutProduct.PutProductBody['xeroLedgerAccountMappings']
}

type UseUpdateProduct = () => {
  editProduct: (
    id: string,
    updatedProduct: UpdatedProduct
  ) => Promise<Product | null>
}

export const useUpdateProduct: UseUpdateProduct = () => {
  const flags = useFeatureFlags()
  const editProduct = useCallback(
    async (id: string, updatedProduct: UpdatedProduct) => {
      const { xeroLedgerAccountMappings, ...rest } = updatedProduct
      const requestBody = omit(rest, [
        'createdAt',
        'updatedAt',
        'id',
        ...(flags.useRevRec ? [] : ['revenueRecognitionMethod'])
      ])
      const xeroMappings =
        xeroLedgerAccountMappings === undefined
          ? {}
          : { xeroLedgerAccountMappings }

      const response = await dashboardv99990101Client.putProduct({
        id,
        body: {
          ...requestBody,
          name: requestBody.name ?? '',
          ...xeroMappings
        }
      })

      if (response.error || !response.data) {
        return null
      }

      return response.data
    },
    [flags.useRevRec]
  )

  return {
    editProduct
  }
}
